export const CarouselItem = ({ imgUrl, imgTitle, width }: any) => (
  <div
    className="carousel-item h-full flex justify-center items-center px-5"
    style={{ width }}
  >
    <img className="w-auto h-full max-w-[none]" src={imgUrl} alt={imgTitle}></img>
  </div>
);
